export enum ModuloTypes {
    SELECIONAR = '@modulo/SELECIONAR',
}

export interface ModuloState {
    // Modulo escolhido no seletor. So preferencia de tela: quem decide o que
    // o usuario ve e o acesso que veio do backend.
    readonly atual: string | null,
}
